// extracted by mini-css-extract-plugin
module.exports = {"list":"MobileCards_list__6w8T3","hide":"MobileCards_hide__tRiby"};